export default "__VITE_ASSET__DjiLVLbp__"